import React, { useEffect, useState } from "react";
import { FaMoneyBillWave, FaUserTie, FaBullhorn } from "react-icons/fa";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { notificationList } from "../../../api/NotificationService";
import { ToastMain ,SweetAlertShow} from "../../master/Master";
import { useNavigate } from "react-router-dom";

const ALERT_TYPES = ["fees", "enquiry", "marketing"];

const ALERT_CONFIG = {
  fees: {
    label: "Fee",
    icon: <FaMoneyBillWave />,
    color: "rgb(140, 87, 255)",
    bg: "#ede7ff",
  },
  enquiry: {
    label: "Enquiry",
    icon: <FaUserTie />,
    color: "#198754",
    bg: "#d1e7dd",
  },
  marketing: {
    label: "Marketing",
    icon: <FaBullhorn />,
    color: "#0d6efd",
    bg: "#cff4fc",
  },
};

const Alert = () => {
  const [type, setType] = useState("fees");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (type === "fees") {
      navigate("/fees/collection/followUp");
    } else if (type === "enquiry") {
      navigate("/enquiry/followups");
    } else {
      navigate("/Followup");
    }
  };

  const fetchNotification = async (selectedType) => {
  setLoading(true);
  setData([]); 

  try {
    const response = await notificationList(`&type=${selectedType}`);

    if (response?.data?.status) {
      setData(response?.data?.data || []);
    } else {
      setData([]);
      // ToastMain.fire({
      //   icon: "info",
      //   title: response?.data?.message || "Something went wrong",
      // });

      SweetAlertShow('info','warning',response?.data?.message)
    }
  } catch (error) {
    setData([]);
    // ToastMain.fire({
    //   icon: "error",
    //   title: error?.response?.data?.message || "Something went wrong",
    // });
    SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
  } finally {
    setLoading(false);
  }
};



  useEffect(() => {
    fetchNotification(type);
  }, [type]);

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="content-wrapper mt-4">
            <div className="container-fluid">
              <div className="card mb-2">
                <div className="card-body">
                  <h3 className="text-center mb-4 fw-bold">Today Notification</h3>

                  {/* Filter Buttons */}
                  <div className="d-flex justify-content-center gap-3 mb-4">
                    {ALERT_TYPES.map((t) => (
                      <button
                        key={t}
                        onClick={() => setType(t)}
                        className={`btn ${
                          t === type ? "btn-primary" : "btn-outline-secondary"
                        }`}
                      >
                        {t.toUpperCase()}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Alerts Table */}
              <div className="card shadow-sm">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0 text-center">
                      <thead className="table-primary">
                        <tr>
                          <th>#</th>
                          <th>Student</th>
                          <th>Phone</th>
                          <th>Type</th>
                          <th>Message / Response</th>
                          <th>Next Followup</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                              Loading...
                            </td>
                          </tr>
                        ) : data.length ? (
                          data.map((alert, index) => {
                            const config = ALERT_CONFIG[alert.type];
                            return (
                              <tr key={alert.id}>
                                <td>{index + 1}</td>
                                <td>
                                  {alert.student?.student_info?.name ?? alert?.inquiry?.student_name}{" "}
                                  {alert?.student?.registration_no || ""}
                                </td>
                                <td>{alert.student?.student_info?.phone ?? alert?.inquiry?.mobile}</td>
                                <td>
                                  <span
                                    className="d-flex align-items-center gap-1 justify-content-center"
                                    style={{ color: config.color }}
                                  >
                                    {config.icon}
                                    <strong>{config.label}</strong>
                                  </span>
                                </td>
                                <td>{alert.response || alert.message || "-"}</td>
                                <td>{alert.next_followup_date || "-"}</td>
                                <td>
                                  <span
                                    className="badge"
                                    style={{
                                      background: config.bg,
                                      color: config.color,
                                    }}
                                  >
                                    {alert.status === "1" ? "Active" : "Inactive"}
                                  </span>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={handleNavigate}
                                  >
                                    Re-contact
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center text-muted">
                              No alerts found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Alert;
